export default __webpack_public_path__ + "5e601327c8f84acc76b6e35f4cc3a37c.svg";